"use client";

import { Ship, LifeBuoy, Mountain, GitBranch, Fan } from 'lucide-react';
import type React from 'react';
import type { HazardType } from '@/types';

export const PlayerShipIcon = ({ className, style }: { className?: string, style?: React.CSSProperties }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path d="M12 2L5 16H4C4 20 8 22 12 22S20 20 20 16H19L12 2z" />
  </svg>
);

export const SharkFinIcon = ({ className, style }: { className?: string, style?: React.CSSProperties }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={style}
  >
    <path d="M3 13.184C3.333 11.184 5.167 6.184 12 4c6.833 2.184 8.667 7.184 9 9.184" />
    <path d="M2 17h20" />
    <path d="M5 20h14" />
  </svg>
);

export const HazardIcon = ({ type, className, style }: { type: HazardType, className?: string, style?: React.CSSProperties }) => {
  switch (type) {
    case 'shark':
      return <SharkFinIcon className={className} style={style} />;
    case 'buoy':
      return <LifeBuoy className={className} style={style} />;
    case 'ship':
      return <Ship className={className} style={style} />;
    case 'kraken':
      return <GitBranch className={className} style={style} />;
    case 'whirlpool':
      return <Fan className={className} style={style} />;
    case 'rocks':
      return <Mountain className={className} style={style} />;
    default:
      return null;
  }
};
